<template>
  <v-card class="d-flex flex-column">
    <v-card-title>
      <v-row no-gutters>
        <v-icon large class="pr-2">mdi-calendar-today</v-icon>
        <h3>{{ $t("absenceAdministration") }}</h3>
      </v-row>
    </v-card-title>
    <v-card-text class="flex-grow-1 overflow-auto">
      <v-data-table :items="absences" hide-default-header :headers="absencesTableHeader" hide-default-footer style="min-height: 240px">
        <template v-slot:item.Farbcode="{ item }">
          <v-icon width="20%" :style="'color: ' + item.Farbcode + ';'">mdi-checkbox-blank-circle</v-icon>
        </template>
      </v-data-table>
    </v-card-text>
    <v-card-actions>
      <v-row justify="end" no-gutters>
        <v-btn rounded style="color: white" class="mr-2 mb-2" color="#990000" @click="ShowAbsenceAdministration = true">{{ $t("manage") }}</v-btn>
      </v-row>
    </v-card-actions>
    <AbsenceAdministration v-if="ShowAbsenceAdministration" @close="ShowAbsenceAdministration = false" />
  </v-card>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "MiniAbsenceAdministration",
  data: (vm) => ({
    ShowAbsenceAdministration: false
  }),
  components: {
    AbsenceAdministration: () => import("../Settings/AbsenceAdministrationDialog")
  },
  created: async function () {},
  computed: {
    absencesTableHeader: function (vm) {
      return [
        {
          text: vm.$t("colorCode"),
          value: "Farbcode",
          hint: "Farbcode",
          sortable: true,
          class: "primary--text font-weight-bold subheading"
        },
        {
          text: vm.$t("name"),
          value: "name",
          hint: "Name",
          sortable: true,
          class: "primary--text font-weight-bold subheading"
        }
      ];
    },
    ...mapGetters({ absences: "server/absences" })
  }
};
</script>

<style></style>
